import './brokerBrokerIAView.scss';

// @vendor
import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

// @helpers
import { i18n } from 'core/i18n';

// @constants
import { scrollToTop } from 'commonsUtilities/scrollUtils';
import {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_STOCKS_URL,
    BROKER_RISK_TYPE_SIX,
} from 'constants/index';
import { NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES } from 'constants/flagBasedFeatures';

// @components
import BrokerRiskInformationBox from 'components/broker/brokerRiskInformationBox/brokerRiskInformationBox';
import BrokerTruncatedBreadcrumb from 'components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb';
import Highlights from 'components/broker/brokerIA/brokerIAComponents/highlights/highlights';
import FrequentlyAskedQuestions from 'components/broker/brokerIA/brokerIAComponents/frequentlyAskedQuestions/frequentlyAskedQuestions';
import CallMeBack from 'components/broker/brokerIA/brokerIAComponents/callMeBack/callMeBack';
import BrokerIAInvestmentModule from 'components/broker/brokerIA/brokerIAComponents/brokerIAInvestmentModule/brokerIAInvestmentModule';

const BrokerBrokerIAView = ({ immFlagBasedFeatures, immProfile, location }) => {
    // Check if feature is enabled
    const brokerIAFlag = immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
    const country = immProfile.get('originCountry');
    const brokerIAEnabled = !!brokerIAFlag && !brokerIAFlag.includes(country);

    if (!brokerIAEnabled) {
        return <Redirect to={'/myprofile/broker/general'} from={location.pathname} />;
    }

    // If feature is enabled continue as usual
    const { formatText } = i18n;
    const breadcrumb = [
        {
            text: formatText('funds-investments'),
            url: MYPROFILE_BROKER_URL,
        },
        {
            text: formatText('stocks-stocks'),
            url: MYPROFILE_BROKER_STOCKS_URL,
        },
        {
            text: formatText('brokerIA-brokerIA'),
            url: '',
        },
    ];

    useEffect(() => {
        scrollToTop();
    }, []);

    const subtitle = (
      <div className="brokerIA-view__subtitle-two-lines-container">
        <p className="brokerIA-view__subtitle-two-lines-container__first-line">
            {formatText('brokerIA-landing_subtitle_first_line')}
        </p>
        <p className="brokerIA-view__subtitle-two-lines-container__second-line">
          {formatText('brokerIA-landing_subtitle')}
        </p>
      </div>
    );

    return (
        <div className="brokerIA-view">
            <div className="brokerIA-view__container">
                <div className="brokerIA-view__header">
                    <BrokerRiskInformationBox riskType={BROKER_RISK_TYPE_SIX} />
                    <BrokerTruncatedBreadcrumb
                        titleKey="brokerIA-brokerIA"
                        breadcrumbConfig={breadcrumb}
                        subtitleLeft={subtitle}
                    />
                    <Highlights />
                </div>
                <div className="brokerIA-view__content">
                    <BrokerIAInvestmentModule country={country} />
                </div>
                <div className="brokerIA-view__footer">
                    <FrequentlyAskedQuestions />
                    <CallMeBack />
                </div>
            </div>
        </div>
    );
};

BrokerBrokerIAView.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

export default connect(state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
    immProfile: state.profile,
}))(withRouter(BrokerBrokerIAView));
